export const resolveAvatarUrl = (rawAvatar) => {
    if (typeof rawAvatar === 'string') {
        return rawAvatar;
    }
    if (rawAvatar && typeof rawAvatar === 'object') {
        const url = rawAvatar['url'];
        if (typeof url === 'string') {
            return url;
        }
    }
    return undefined;
};
export const resolveDisplayName = (profile) => {
    const candidates = [profile.displayName, profile.fullName, profile.preferredName, profile.email];
    for (const value of candidates) {
        if (typeof value === 'string' && value.trim().length > 0) {
            return value.trim();
        }
    }
    return 'Profile';
};
//# sourceMappingURL=profile.js.map